/**
 *
 * @type {{ONE_TIME: string, SUBSCRIPTION: string}}
 */
const PriceType = {
  ONE_TIME: 'oneTime',
  SUBSCRIPTION: 'subscription'
};

export { PriceType };
